/**
 * Copyright (C) Radiojar S.A. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
import JobsApi from "@/services/Jobs";

export default {
	state: () => ({
		jobs: []
	}),

	getters: {
		getJobs: (state) => () => {
			return state.jobs;
		},

		getJobsKeys: (state) => () => {
			return state.jobs.map(j => j.JobKey);
		}
	},

	mutations: {
		addJob(state, job) {
			if (!state.jobs.map(j => j.JobKey).includes(job.JobKey)) {
				state.jobs.unshift(job);
			}
		},

		updateJob(state, payload) {
			const jobIndex = state.jobs.findIndex(j => j.JobKey === payload.JobKey);
			if (jobIndex >= 0) {
				state.jobs.splice(jobIndex, 1, payload);
			}
			else {
				state.jobs.unshift(payload);
			}
		},

		removeJobByKey(state, JobKey) {
			const jobIndex = state.jobs.findIndex(j => j.JobKey === JobKey);
			state.jobs.splice(jobIndex, 1);
		}
	},

	actions: {
		runJob(state, payload) {
			return JobsApi.runJob(payload)
						  .then(response => response.data);
		},

		updateJobState({commit}, job) {
			return JobsApi.getJobState(job.JobKey)
						  .then(response => {
							  const updatedJob = {
								  JobKey: response.data.JobKey,
								  Status: response.data.JobStatus,
								  Description: response.data.Description,
								  JobTime: job.JobTime,
								  JobMessage: job.JobMessage,
							  };

								  commit("updateJob", updatedJob);
							  });
		},

		assetJobSchedule(state, AssetID) {
			return JobsApi.assetJobSchedule(state, AssetID);
		},

		useImportServiceGraphql() {
			return JobsApi.useImportServiceGraphql();
		},

		createAssetImport(state, request) {
				return JobsApi.createAssetImport(request);
		},

		getScheduleHistory(state, scheduleKey) {
			return JobsApi.getScheduleHistory(scheduleKey);
		}
	}
};
